var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 83.871,
    viewBox: "0 0 90 83.871",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "my_order",
    transform: "translate(-9 -25.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8419",
    "data-name": "Path 8419",
    d: "M93.519,61.773H88.981a4.47,4.47,0,0,0-4.266-3.279H79.87V46.648a1.25,1.25,0,0,0-.61-1.1L45.087,25.8a1.262,1.262,0,0,0-1.268,0L9.634,45.543A1.272,1.272,0,0,0,9,46.648V86.125a1.275,1.275,0,0,0,.638,1.1l34.188,19.738a1.275,1.275,0,0,0,.638.171,1.341,1.341,0,0,0,.656-.171L63.11,96.586v7.5a5.4,5.4,0,0,0,5.446,5.414H93.519A5.43,5.43,0,0,0,99,104.092V67.272a5.5,5.5,0,0,0-5.48-5.5Zm-8.759-.729A1.851,1.851,0,0,1,86.611,62.9v.124a1.851,1.851,0,0,1-1.851,1.851H77.349A1.851,1.851,0,0,1,75.5,63.019V62.9a1.851,1.851,0,0,1,1.851-1.851ZM44.46,28.381l14.206,8.2L27.034,54.848l-14.206-8.2Zm-1.212,75.272-31.7-18.266V48.854l31.7,18.266ZM44.46,64.91,29.584,56.32,61.22,38.056l14.88,8.59Zm18.646,2.362V93.646L45.8,103.654V67.119L77.32,48.854v9.64h.04a4.47,4.47,0,0,0-4.266,3.279H68.555a5.472,5.472,0,0,0-5.446,5.5Zm33.34,36.82a2.877,2.877,0,0,1-2.93,2.864H68.555a2.847,2.847,0,0,1-2.9-2.864V67.272a2.919,2.919,0,0,1,2.9-2.948h4.588a4.362,4.362,0,0,0,4.217,3.1h7.355a4.362,4.362,0,0,0,4.216-3.1h4.588a2.949,2.949,0,0,1,2.93,2.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8420",
    "data-name": "Path 8420",
    d: "M338.116,285.548h1.177a1.124,1.124,0,0,0,0-2.248h-.044v-3.051h3.1a1.082,1.082,0,0,0,1.069.759,1.127,1.127,0,0,0,1.13-1.122v-.756a1.139,1.139,0,0,0-1.136-1.13h-5.3A1.122,1.122,0,0,0,337,279.13v5.3a1.116,1.116,0,0,0,1.116,1.123Z",
    transform: "translate(-267.498 -205.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8421",
    "data-name": "Path 8421",
    d: "M338.124,349.548h5.3a1.124,1.124,0,0,0,1.124-1.124v-5.3A1.124,1.124,0,0,0,343.424,342h-5.3A1.124,1.124,0,0,0,337,343.124v5.3A1.124,1.124,0,0,0,338.124,349.548Zm1.124-5.3H342.3V347.3h-3.051Z",
    transform: "translate(-267.499 -257.952)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8422",
    "data-name": "Path 8422",
    d: "M339.292,411.3h-.044v-3.051h3.04a1.13,1.13,0,0,0,2.26,0v-1.083A1.172,1.172,0,0,0,343.411,406h-5.3A1.155,1.155,0,0,0,337,407.167v5.3a1.084,1.084,0,0,0,1.116,1.085h1.177a1.124,1.124,0,0,0,0-2.248Z",
    transform: "translate(-267.498 -309.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8423",
    "data-name": "Path 8423",
    d: "M360.568,284.868l-3.292,3.292-1-1a1.124,1.124,0,0,0-1.59,1.59l1.8,1.8a1.124,1.124,0,0,0,1.59,0l4.088-4.088a1.124,1.124,0,0,0-1.59-1.59Z",
    transform: "translate(-281.584 -211.212)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8424",
    "data-name": "Path 8424",
    d: "M360.568,414.117l-3.292,3.292-1-1a1.124,1.124,0,0,0-1.59,1.59l1.8,1.8a1.124,1.124,0,0,0,1.59,0l4.088-4.088a1.124,1.124,0,0,0-1.59-1.59Z",
    transform: "translate(-281.584 -315.879)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8425",
    "data-name": "Path 8425",
    d: "M422.076,295h-7.061a1.124,1.124,0,1,0,0,2.248h7.061a1.124,1.124,0,0,0,0-2.248Z",
    transform: "translate(-329.202 -220.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8426",
    "data-name": "Path 8426",
    d: "M422.076,359h-7.061a1.124,1.124,0,1,0,0,2.248h7.061a1.124,1.124,0,1,0,0-2.248Z",
    transform: "translate(-329.202 -272.406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8427",
    "data-name": "Path 8427",
    d: "M422.076,423h-7.061a1.124,1.124,0,1,0,0,2.248h7.061a1.124,1.124,0,1,0,0-2.248Z",
    transform: "translate(-329.202 -323.612)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyOrders);
export default __webpack_public_path__ + "static/media/my_orders.464b02cc83c8bf162f9343f4c771b065.svg";
export { ForwardRef as ReactComponent };